import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/TextInputGroup/text-input-group.mjs';
import { css } from '@patternfly/react-styles';
export const TextInputGroupUtilities = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (React.createElement("div", Object.assign({ className: css(styles.textInputGroupUtilities, className) }, props), children));
};
TextInputGroupUtilities.displayName = 'TextInputGroupUtilities';
//# sourceMappingURL=TextInputGroupUtilities.js.map